import "./StoreRecentBought.scss";

export const StoreRecentBought = (props) => {
  const { packageData } = props;

  return (
    <div
      className="recent-bought-container"
      style={{
        padding: "5px",
        marginTop: "10px",
      }}
    >
      <span dangerouslySetInnerHTML={{ __html: packageData?.text }} />
    </div>
  );
};
